$(document).ready(function () {
    // calculate price
    let inputSelected = null;
    let varSelected = null;
    let product_price = null;
    let variant_id = null;
    let prepay_save_value_for_cart = null;
    let selling_plan_id = null;
    let subscription_enabled_for_cart = false;
    // $(".prod-block-wrapper .sas-box .sas-options .variant-opt-label.auto-renew-prod.multiple-variants").click();
    $(".prod-block-wrapper .sas-box .sas-options .variant-opt-label").click(function(){
        $(".prod-block-wrapper .sas-box .sas-options .variant-opt-label").removeClass("active");
        $(".prod-block-wrapper .sas-box .sas-options input[type=radio]:checked").prop("checked", "");
        $(this).siblings("input").prop("checked", "true");
        $(this).addClass("active");
        calculatePrice();
    });
    $(".prod-block-wrapper .prepay_save-select").change(function(){
        calculatePrice();
    });
    $(".prod-block-wrapper .select__select.product-varinat-selector").change(function(){
        calculatePrice();
    });
    $(".prod-block-wrapper .product-form-variant-select").change(function(){
        calculatePrice();
    });
    function calculatePrice(){
        let length = 0;
        let subscription_enabled = false;
        // $(".sas-options input[type=radio]").each(function(){
        //     if($(this).is(":checked")){
        //         inputSelected = $(this).val();
        //     }
        // });
        varSelected = $(".product-form__input .select__select.product-varinat-selector option:selected").val();
        $(".product-form__input input[type=radio]").each(function(){
            if($(this).is(":checked")){
                varSelected = $(this).val();
            }
        });
        $(".prod-block-wrapper .sas-box .sas-options .variant-opt-label").each(function(){
            if($(this).hasClass("active")){
                length += 1;
                let prepay_save_value = null;
                $(".product-template-wrapper .product-price").show();
                $(".product-template-wrapper .show-dynamic-prices").hide();
                if($(this).hasClass("auto-renew-prod")){
                    $(".prod-block-wrapper .sas-box-prepay-save").show();
                    subscription_enabled = true;
                    if($(this).parents(".sas-options").hasClass("prepay_save_enabled")){
                        prepay_save_value = $(".prod-block-wrapper .prepay_save-select").val();
                        if(prepay_save_value == "0"){
                            let showDynamicPrice = $(".product-template-wrapper .show-dynamic-prices");
                            let showDynamicPriceA = $(showDynamicPrice).attr('show-dynamic-price');
                            if(showDynamicPriceA === "enabled"){
                                $(".product-template-wrapper .product-price").hide();
                                $(showDynamicPrice).show();
                                $(".product-prices .subscription-prod-price .product-id-for-cart").each(function(){
                                    if(varSelected == $(this).attr('variant-title')){
                                        product_price = $(this).attr('variant-price');
                                        console.log(product_price);
                                        return false;
                                    }else{
                                        product_price = $(".product-prices").find(".subscription-prod-price").find('.prod-pri').text()
                                    }
                                });
                            }else{
                                // product_price = $(".product-prices .subscription-prod-price .prod-pri").text();
                                $(".product-prices .subscription-prod-price .product-id-for-cart").each(function(){
                                    if(varSelected == $(this).attr('variant-title')){
                                        product_price = $(this).attr('variant-price');
                                        console.log(product_price);
                                        return false;
                                    }else{
                                        product_price = $(".product-prices").find(".subscription-prod-price").find('.prod-pri').text()
                                    }
                                });
                            }
                            console.log(product_price);
                        }else if(prepay_save_value == "3"){
                            product_price = $(".product-prices .three-months-prod-price .prod-pri").text();
                            $(".product-prices .three-months-prod-price .product-id-for-cart").each(function(){
                                if(varSelected == $(this).attr('variant-title')){
                                    product_price = $(this).attr('variant-price');
                                    return false;
                                }else{
                                    product_price = $(".product-prices").find(".three-months-prod-price").find('.prod-pri').text()
                                }
                            });
                        }else if(prepay_save_value == "6"){
                            product_price = $(".product-prices .six-months-prod-price .prod-pri").text();
                            $(".product-prices .six-months-prod-price .product-id-for-cart").each(function(){
                                if(varSelected == $(this).attr('variant-title')){
                                    product_price = $(this).attr('variant-price');
                                    return false;
                                }else{
                                    product_price = $(".product-prices").find(".six-months-prod-price").find('.prod-pri').text()
                                }
                            });
                        }else if(prepay_save_value == "12"){
                            product_price = $(".product-prices .twelve-months-prod-price .prod-pri").text();
                            $(".product-prices .twelve-months-prod-price .product-id-for-cart").each(function(){
                                if(varSelected == $(this).attr('variant-title')){
                                    product_price = $(this).attr('variant-price');
                                    return false;
                                }else{
                                    product_price = $(".product-prices").find(".twelve-months-prod-price").find('.prod-pri').text()
                                }
                            });
                        }else{
                            product_price = $(".product-prices .subscription-prod-price .prod-pri").text();
                            $(".product-prices .subscription-prod-price .product-id-for-cart").each(function(){
                                if(varSelected == $(this).attr('variant-title')){
                                    product_price = $(this).attr('variant-price');
                                    return false;
                                }else{
                                    product_price = $(".product-prices").find(".subscription-prod-price").find('.prod-pri').text()
                                }
                            });
                        }
                    }
                }else{
                    // product_price = $(".product-prices .original-prod-price .prod-pri").text();
                    $(".product-prices .original-prod-price .product-id-for-cart").each(function(){
                        if(varSelected == $(this).attr('variant-title')){
                            product_price = $(this).attr('variant-price');
                            return false;
                        }else{
                            product_price = $(".product-prices").find(".original-prod-price").find('.prod-pri').text()
                        }
                    });
                    $(".prod-block-wrapper .sas-box-prepay-save").hide();
                }
                if(product_price != null){
                    if(subscription_enabled){
                        $(".product-template-wrapper .product-price .original-price").text(product_price);
                        $(".custom-add-to-cart-btn .prod-price-in-ATC").text(product_price);
                        if($(this).hasClass("auto-renew-prod")){
                            if(prepay_save_value == "0"){
                                $(".product-template-wrapper .product-price .original-price").append(`
                                    <span class="sub-text">/ Mo</span>
                                `);
                            }else{
                                $(".product-template-wrapper .product-price .original-price").append(`
                                    <span class="sub-text">/ ${prepay_save_value} Mo</span>
                                `);
                            }
                        }
                    }
                }
            }
        });
        if(!subscription_enabled){
            // $(".product-template-wrapper .product-price .original-price").text($(".product-prices .original-prod-price .prod-pri").text());
            $(".product-prices .original-prod-price .product-id-for-cart").each(function(){
                if(varSelected == $(this).attr('variant-title')){
                    $(".product-template-wrapper .product-price .original-price").text($(this).attr('variant-price'));
                    $(".custom-add-to-cart-btn .prod-price-in-ATC").text($(this).attr('variant-price'));
                    return false;
                }else{
                    $(".product-template-wrapper .product-price .original-price").text($(".product-prices").find(".original-prod-price").find('.prod-pri').text());
                    $(".custom-add-to-cart-btn .prod-price-in-ATC").text($(".product-prices").find(".original-prod-price").find('.prod-pri').text());
                }
            });
        } 
    }
    calculatePrice();
    // check product ID For cart
    function calculateProductIDForCart(){
        let length = 0;
        inputSelected = $(".product-form__input .select__select.product-varinat-selector option:selected").val();
        $(".product-form__input input[type=radio]").each(function(){
            if($(this).is(":checked")){
                inputSelected = $(this).val();
            }
        });
        console.log("inputSelected aft "+inputSelected);
        console.log(inputSelected);
        $(".prod-block-wrapper .sas-box .sas-options .variant-opt-label").each(function(){
            if($(this).hasClass("active")){
                length += 1;
                console.log(inputSelected);
                if($(this).hasClass("auto-renew-prod")){
                    subscription_enabled_for_cart = true;
                    if($(this).parents(".sas-options").hasClass("prepay_save_enabled")){
                        prepay_save_value_for_cart = $(".prod-block-wrapper .prepay_save-select").val();
                        if(prepay_save_value_for_cart == "0"){
                            $(".product-prices .subscription-prod-price .product-id-for-cart").each(function(){
                                if(inputSelected != undefined){
                                    if(inputSelected == $(this).attr('variant-title')){
                                        variant_id = parseInt($(this).text());
                                        console.log(variant_id);
                                    }
                                }else{
                                    variant_id = parseInt($(this).text());
                                }
                            });
                            selling_plan_id = $(".product-prices .subscription-prod-price").attr('selling-plan');
                        }else if(prepay_save_value_for_cart == "3"){
                            $(".product-prices .three-months-prod-price .product-id-for-cart").each(function(){
                                console.log(inputSelected);
                                console.log($(this).attr('variant-title'));
                                if(inputSelected != undefined){
                                    if(inputSelected == $(this).attr('variant-title')){
                                        variant_id = parseInt($(this).text());
                                        console.log(variant_id);
                                    }
                                }else{
                                    variant_id = parseInt($(this).text());
                                }
                            });
                            selling_plan_id = $(".product-prices .three-months-prod-price").attr('selling-plan');
                        }else if(prepay_save_value_for_cart == "6"){
                            $(".product-prices .six-months-prod-price .product-id-for-cart").each(function(){
                                if(inputSelected != undefined){
                                    if(inputSelected == $(this).attr('variant-title')){
                                        variant_id = parseInt($(this).text());
                                        console.log(variant_id);
                                    }
                                }else{
                                    variant_id = parseInt($(this).text());
                                }
                            });
                            selling_plan_id = $(".product-prices .six-months-prod-price").attr('selling-plan');
                        }else if(prepay_save_value_for_cart == "12"){
                            $(".product-prices .twelve-months-prod-price .product-id-for-cart").each(function(){
                                if(inputSelected != undefined){
                                    if(inputSelected == $(this).attr('variant-title')){
                                        variant_id = parseInt($(this).text());
                                        console.log(variant_id);
                                    }
                                }else{
                                    variant_id = parseInt($(this).text());
                                }
                            });
                            selling_plan_id = $(".product-prices .twelve-months-prod-price").attr('selling-plan');
                        }else{
                            $(".product-prices .subscription-prod-price .product-id-for-cart").each(function(){
                                if(inputSelected != undefined){
                                    if(inputSelected == $(this).attr('variant-title')){
                                        variant_id = parseInt($(this).text());
                                        console.log(variant_id);
                                    }
                                }else{
                                    variant_id = parseInt($(this).text());
                                }
                            });
                            selling_plan_id = $(".product-prices .subscription-prod-price").attr('selling-plan');
                        }
                    }
                }else{
                    subscription_enabled_for_cart = false;
                    $(".product-prices .original-prod-price .product-id-for-cart").each(function(){
                        if(inputSelected != undefined){
                            if(inputSelected == $(this).attr('variant-title')){
                                variant_id = parseInt($(this).text());
                                console.log(variant_id);
                            }
                        }else{
                            variant_id = parseInt($(this).text());
                        }
                    });
                    selling_plan_id = $(".product-prices .original-prod-price").attr('selling-plan');
                }
            }
        });
        if(!subscription_enabled_for_cart){
            $(".product-prices .original-prod-price .product-id-for-cart").each(function(){
                if(inputSelected != undefined){
                    if(inputSelected == $(this).attr('variant-title')){
                        variant_id = parseInt($(this).text());
                        console.log(variant_id);
                    }
                }else{
                    variant_id = parseInt($(this).text());
                }
            });
            selling_plan_id = $(".product-prices .original-prod-price").attr('selling-plan');
        } 
    }
    calculateProductIDForCart();

    // subscribe and save
    $(".custom-add-to-cart-btn.non-trial_product-atc button").click(function (e) { 
        let properties = {};

        e.preventDefault();
        $(".product-form__input input[type=radio]").each(function(){
            if($(this).is(":checked")){
                inputSelected = $(this).val();
            }
        });
        calculateProductIDForCart();

        $("#BT5 .prod-block-dummy-flavors-wrapper .dummy-flavor-options-block .dummy-flavor-option-bl input").each(function () {
            if ($(this).is(":checked")) {
                // push flavorName to properties
                properties["Flavor"] = $(this).attr("flavor-name");
            }
        });
        $("#BT5 .prod-block-dummy-sizes-wrapper .dummy-size-options-block .dummy-size-option-bl input").each(function () {
            if ($(this).is(":checked")) {
                // push flavorName to properties
                properties["Size"] = $(this).attr("variant-type");
            }
        });


        // console.log(selling_plan_id);
        console.log("subscription_enabled_for_cart: "+subscription_enabled_for_cart);
        console.log("variant_id: "+variant_id);
        console.log("selling_plan_id: "+selling_plan_id);
        console.log("properties: "+JSON.stringify(properties));

        if(subscription_enabled_for_cart){
            $.ajax({
                type: "POST",
                url: "/cart/add.js",
                data: {
                    quantity: $(".product-template-wrapper .product__info-wrapper .quantity .quantity__input").val(),
                    id: variant_id,
                    selling_plan: selling_plan_id,
                    properties: properties
                },
                dataType: "json",
                success: function(data) {
                    console.log(data.id);
                    
                },
                error: function(data){
                    console.log(data.responseText);
                }
            });
        }else{
            $.ajax({
                type: "POST",
                url: "/cart/add.js",
                data: {
                    quantity: $(".product-template-wrapper .product__info-wrapper .quantity .quantity__input").val(),
                    id: variant_id,
                    properties: properties
                },
                dataType: "json",
                success: function(data) {
                    console.log(data.id);
                    
                },
                error: function(data){
                    console.log(data.responseText);
                }
            });
        }
    });
    $(".custom-add-to-cart-btn.trial_product-atc button").click(function (e) { 
        e.preventDefault();
        $(".product-form__input input[type=radio]").each(function(){
            if($(this).is(":checked")){
                inputSelected = $(this).val();
            }
        });
        calculateProductIDForCart();
        // console.log(selling_plan_id);
        console.log("subscription_enabled_for_cart: "+subscription_enabled_for_cart);
        console.log("variant_id: "+variant_id);
        console.log("selling_plan_id: "+selling_plan_id);
        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: {
                quantity: $(".product-template-wrapper .product__info-wrapper .quantity .quantity__input").val(),
                id: parseInt($(".product-prices .original-prod-price .produ-var .product-id-for-cart").text()),
                selling_plan: selling_plan_id
            },
            dataType: "json",
            success: function(data) {
                console.log(data.id);
                
            },
            error: function(data){
                console.log(data.responseText);
            }
        });
    });

    $("#BT5 .PCS .add-bundles-to-cart").click(function(e){
        e.preventDefault();
        let variant_id_b = $(this).attr("variant-id");
        let sellingPlan  = $(this).attr("selling-plan");
        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: {
                quantity: 1,
                id: variant_id_b,
                selling_plan: sellingPlan 
            },
            dataType: "json",
            success: function(data) {
                console.log(data.id);
                
            },
            error: function(data){
                console.log(data.responseText);
            }
        });
    });


    
  // Trigger change event on the first dummy flavor input
});